import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiVisa, BaseApiTemplateService, BasicApiResponseModel} from '../../shared';
import {Core2Config} from '../../shared';
import { ClaimCycleHdrContainerModel} from '../../../../../../models';
import {Observable} from 'rxjs';

export class SummaryStatisticsRequestBody {
  claim_cycle_hdr_guid: string;
  latest_reviewed_levels: number[];
  payment_processing_options?: string[];
}

export class SummaryStatisticsContainer {
  total_claim_document_lines: number;
  total_not_yet_reviewed: number;
  total_reviewed_by_level_1: number;
  total_reviewed_by_level_2: number;
  total_reviewed_by_level_3: number;
  total_reviewed_by_level_4: number;
}

@Injectable({
  providedIn: 'root'
})
export class ClaimCycleHdrService extends BaseApiTemplateService<ClaimCycleHdrContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX + Core2Config.CLAIMS_PREFIX + 'cycle-hdrs/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX + Core2Config.CLAIMS_PREFIX + 'cycle-hdrs/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX + Core2Config.CLAIMS_PREFIX + 'cycle-hdrs/backoffice-ep';
    this.httpClient = http;
  }

  getSummaryStatistics(body: SummaryStatisticsRequestBody, apiVisa: ApiVisa): Observable<BasicApiResponseModel<SummaryStatisticsContainer>> {
    let apiUrl = Core2Config.DOMAIN_URL + 'core2/tnt/dm/erp/aat/claims/cycle-hdrs/public/summary-statistics/backoffice-ep';
    if (apiVisa && apiVisa.api_domain_url) {
      apiUrl = apiVisa.api_domain_url + 'core2/tnt/dm/erp/aat/claims/cycle-hdrs/public/summary-statistics/backoffice-ep';
    }
    return this.httpClient.post<BasicApiResponseModel<SummaryStatisticsContainer>>(apiUrl, body, this.getHttpHeader(apiVisa));
  }

}


